import { CalendarPlatformIdentifier } from "./calendar";
import { PaymentPlatformIdentifier } from "./PaymentPlatform";
import { ReviewPlatformIdentifier } from "./review";
import { SocialMediaIdentifier } from "./social";
export enum IntegrationTypes {
  SOCIAL_MEDIA = "social_media",
  CALENDAR = "calendar",
  REVIEW = "review",
  PAYMENT = "payment",
}
export interface PlatformData {
  id: string;
  name: Integration;
  icon: string;
  description: string;
}

export type Integration =
  | SocialMediaIdentifier
  | ReviewPlatformIdentifier
  | CalendarPlatformIdentifier
  | PaymentPlatformIdentifier;
